import runRequest from "./runRequest";
import buildRequest from "./buildRequest";
function combineAggregationsFromResponses(responses) {
    return responses.reduce((acc, response) => {
        return {
            ...acc,
            ...response.aggregations,
        };
    }, {});
}
// To calculate a disjunctive facet correctly, you need to calculate the facet counts as if the filter was
// not applied. If you did not do this, list of facet values would collapse to just one value, which is
// whatever you have filtered on in that facet.
function removeFilterByName(state, facetName) {
    return {
        ...state,
        filters: (state.filters || []).filter((f) => f.field !== facetName),
    };
}
function removeAllFacetsExcept(body, facetName) {
    return {
        ...body,
        aggs: {
            [facetName]: body.aggs[facetName],
        },
    };
}
function changeSizeToZero(body) {
    return {
        ...body,
        size: 0,
    };
}
async function getDisjunctiveFacetCounts(service, index, state, disjunctiveFacetNames, uiStore, applicationId) {
    // only includes facets to which filters are currently applied
    disjunctiveFacetNames = disjunctiveFacetNames.filter((facetName) => (state.filters || []).some((filter) => filter.field === facetName));
    const responses = await Promise.all(disjunctiveFacetNames.map(async (facetName) => {
        const newState = removeFilterByName(state, facetName);
        let body = await buildRequest(index, service, newState, uiStore);
        body = changeSizeToZero(body);
        body = removeAllFacetsExcept(body, facetName);
        return runRequest(index, body, applicationId);
    }));
    return combineAggregationsFromResponses(responses);
}
/**
 * This function will re-calculate facets that need to be considered
 * "disjunctive" (also known as "sticky").
 * Disjunctive facets are facets that do not change when a selection is made.
 * Meaning, all available options will remain as selectable options even after
 * a selection is made. Calculating sticky facets correctly requires a second
 * query for each sticky facet.
 *
 * @param {string} service
 * @param {string} index
 * @param {JSON} json
 * @param {Context} state
 * @param {string[]} disunctiveFacetNames
 * @param {UIStateStore} uiStore
 * @param {string} [applicationId] the application id to be sent in the header of the API request (optional)
 *
 * @return {Promise<IResponse>} A map of updated aggregation counts for the specified facet names
 */
export default async function applyDisjunctiveFaceting(service, index, json, state, disunctiveFacetNames, uiStore, applicationId) {
    const disjunctiveFacetCounts = await getDisjunctiveFacetCounts(service, index, state, disunctiveFacetNames, uiStore, applicationId);
    return {
        ...json,
        aggregations: {
            ...json.aggregations,
            ...disjunctiveFacetCounts,
        },
    };
}
